import { Shield, ShieldAlert, ShieldCheck } from 'lucide-react';
import type { ConfidenceLevel } from '../../types';

interface ConfidenceBadgeProps {
  level: ConfidenceLevel;
  score?: number;
}

const confidenceConfig: Record<ConfidenceLevel, {
  icon: typeof Shield;
  label: string;
  className: string;
}> = {
  high: {
    icon: ShieldCheck,
    label: 'High confidence',
    className: 'bg-green-100 text-green-700',
  },
  medium: {
    icon: Shield,
    label: 'Medium confidence',
    className: 'bg-yellow-100 text-yellow-700',
  },
  low: {
    icon: ShieldAlert,
    label: 'Low confidence',
    className: 'bg-red-100 text-red-700',
  },
};

/** Displays a color-coded badge indicating the confidence level (high/medium/low) of an assistant response. */
export function ConfidenceBadge({ level, score }: ConfidenceBadgeProps) {
  const config = confidenceConfig[level];
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.className}`}
      title={score !== undefined ? `Confidence: ${Math.round(score * 100)}%` : config.label}
    >
      <Icon size={12} />
      {level}
      {score !== undefined && (
        <span className="ml-0.5 opacity-75">
          ({Math.round(score * 100)}%)
        </span>
      )}
    </span>
  );
}
